// 呼び出し先 - style.js
window.AHKAH = window.AHKAH || {};
  
// 左側：リダイレクト前のURL（https://www.ahkah.com/en/ 以降のパスを記載）
// 右側：リダイレクト先のURL（https://www.ahkah.jp/ 以降のパスを記載）
AHKAH.ridirectUrlMap = {
  'pages/ahkahsignature_chandelier-1':"ext/2025_chandelier_teaser/index.html",
  "ext/AHKAHsignature_chandelier.html": "ext/2025_chandelier_teaser/index.html",
  //"ahkahsignature_chandelier/": "ext/2025_chandelier_teaser/index.html",
  //"store_map/": "ext/shops_map.html",
  //"bridal/store/": "bridal/store/index.html",
}